angular.module('gym.components').controller('SendInvitationEmailCtrl', ["$scope", "$rootScope", "$modalInstance", "$http", "TemplateSanitizeService", "template", "baseUrl", "isUnsubscribedFromEmail", function($scope, $rootScope, $modalInstance, $http, TemplateSanitizeService, template, baseUrl, isUnsubscribedFromEmail) {
  $scope.template = template;
  $scope.isUnsubscribedFromEmail = isUnsubscribedFromEmail;
  $scope.gym = $rootScope.gym;
  $scope.submit = function() {
    var data, params, url;
    $scope.isLoading = true;
    data = TemplateSanitizeService.sanitize($scope.template);
    params = {
      invite_email_subject: data.subject,
      invite_email_content: data.content
    };
    url = `${baseUrl}/send_invitation`;
    return $http.put(url, params).then(function() {
      return $modalInstance.close();
    }, function(response) {
      $scope.error = response.data.error_message;
      return $scope.isLoading = false;
    });
  };
  return $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
